'use client';
import { useTranslations } from 'next-intl';
import { HtmlHTMLAttributes } from 'react';

export default function Info(props: HtmlHTMLAttributes<HTMLDivElement>) {
  const t = useTranslations('contact');
  return (
    <div {...props}>
      <div>
        <h3 className="text-2xl font-bold">{t('section.part1')}&nbsp;</h3>
        {t('section.part2')}
      </div>
      <div>
        <h3 className="text-2xl font-bold">{t('section.part3')}&nbsp;</h3>
        {t('section.part4')}
      </div>
      <div>
        <h3 className="text-2xl font-bold">{t('section.part5')}&nbsp;</h3>
        <p>{t('address.address1')}</p>
        <p>{t('address.address2')}</p>
        <p>{t('address.address3')}</p>
      </div>
    </div>
  );
}
